import React, { useState } from "react";
import { Modal, Button, Rate, notification, Spin , Input} from "antd";
import { useMutation, useQuery } from "@apollo/client";
import moment from "moment";
import { RATE_MUTATION } from "../Apollo/graphql/Mutation/RateMutation";
import { CREATE_COMMENT } from "../Apollo/graphql/Mutation/CommentMutation";
import { Text3D } from "./Text3D";
import { replaceError } from "../utils/utilsFunctions";
import { GET_RATING } from "../Apollo/graphql/Query";

const RatePrinterModal = ({ isRatePrinterVisible, printer, handleClose }) => {
  const [loading, setLoading] = useState(false);
  const [hasRated, setHasRated] = useState(false);
  const [rateMutation] = useMutation(RATE_MUTATION);
  const [createCommentMutation] = useMutation(CREATE_COMMENT);

  const { data, loading:getRatingLoading } = useQuery(GET_RATING, {
    fetchPolicy: "network-only",
    variables: {
      input: {
        type: "starRating",
        resourceId: printer?._id,
        resourceType: "printer",
      },
    },
  });

  const [rating, setRating] = useState<any>(null);
  const [review, setReview] = useState<any>(null);
  const handleOk = async () => {
        try {
          setLoading(true);
          await rateMutation({
            variables: {
              input: {
                type: "starRating",
                resourceId: printer._id,
                resourceType: "printer",
                rating: rating,
                message: review,
              },
            },
          });
          // creating comment, as we are showing comments as reviews at the moment in the printer profile
          await createCommentMutation({
            variables: {
              input: {
                resourceId: printer._id,
                resourceType: "printer",
                comment: review,
              },
            },
          });
          setLoading(false);
          setHasRated(true);
          setTimeout(() => {
            setRating(0);
            setHasRated(false);
            handleClose();
          }, 5000);
        } catch (err) {
          notification.error({
            message: "Error",
            description: replaceError(err),
          });
          setLoading(false);
        }
  }

  return (
    <Modal
      visible={isRatePrinterVisible}
      destroyOnClose={true}
      title={
        <div>
          <div>
            <Text3D textWeight={700}>{printer?.name || ""}</Text3D>
          </div>
          <Text3D textSize="0.9rem">Rate this printer</Text3D>
        </div>
      }
      onOk={handleOk}
      footer={
        hasRated
          ? null
          : [
              <Button
                key="submit"
                type="primary"
                loading={loading}
                onClick={handleOk}
                disabled={!rating ||!review || (review && review.length === 0)}
              >
                Submit
              </Button>,
            ]
      }
      onCancel={() => {
        setRating(0);
        setHasRated(false);
        handleClose();
      }}
    >
      <Spin spinning={getRatingLoading}>
        <div style={{ textAlign: "center" }}>
          {hasRated && (
            <Text3D textWeight={700}>
              You are awesome. <br />
              Thank you for providing us your valuable time.
            </Text3D>
          )}
          {!hasRated && data && (
            <>
              <Rate
                allowHalf
                defaultValue={
                  data.rating && data.rating.rating ? data.rating.rating : 0
                }
                onChange={setRating}
                style={{ fontSize: 36 }}
              />
              {data.rating && (
                <div style={{ marginTop: "1.5rem", textDecoration: "italic" }}>
                  <Text3D textSize="0.8rem" textColor="#AAA">
                    You last rated on:{" "}
                    {moment(data.rating.updatedAt).format("MMM DD,YYYY")}
                  </Text3D>
                </div>
              )}
              <Input.TextArea
                placeholder="How was your experience with this printer ? Leave us a review."
                onChange={(e) => setReview(e.target.value)}
                defaultValue={
                  data.rating && data.rating.message ? data.rating.message : ""
                }
              />
            </>
          )}
        </div>
      </Spin>
    </Modal>
  );
};

export default RatePrinterModal;
